module.exports = __webpack_public_path__ + "linea-ecommerce-10.e8892174d7f87530f38e.ttf";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/linea-icons/fonts/linea-ecommerce-10.ttf
// module id = ../../../../../src/assets/scss/icons/linea-icons/fonts/linea-ecommerce-10.ttf
// module chunks = styles